import { ActionType, NetworkActionPrefix } from '../utils/constants';
import defaults from '../api/defaults';
import { combineReducers, networkEntityAddReducer, networkEntityDeleteReducer, networkEntityEditReducer, networkObjectLoadReducer, pipeReducers } from '../utils/reducerFactory';

function index(list, itemID) {
    if (itemID !== undefined) {
        return list.getIndexByID(itemID) !== -1 ? list.getIndexByID(itemID) : list.length;
    }

    return -1;
}

const userList = pipeReducers(
    combineReducers({
        userDataVisibilityFunctions: pipeReducers(
            networkObjectLoadReducer(NetworkActionPrefix.LOAD_USER_DATA_VISIBILITY_FUNCTIONS_PREFIX, defaults.NetworkArrayOf(defaults.UserDataVisibilityFunction)),
            combineReducers({
                Data: combineReducers({
                    '@index': pipeReducers(
                        networkEntityAddReducer(NetworkActionPrefix.ADD_USER_DATA_VISIBILITY_FUNCTION_PREFIX, null, (state, action) => action.companyFunction),
                        networkEntityDeleteReducer(NetworkActionPrefix.DELETE_USER_DATA_VISIBILITY_FUNCTION_PREFIX, defaults.UserDataVisibilityFunction)
                    )
                }, {
                    index: (state, action) => index(state, action.companyFunctionID)
                })
            })
        ),
        userDataVisibilityLegalEntities: pipeReducers(
            networkObjectLoadReducer(NetworkActionPrefix.LOAD_USER_DATA_VISIBILITY_LEGAL_ENTITIES_PREFIX, defaults.NetworkArrayOf(defaults.UserDataVisibilityLegalEntity)),
            combineReducers({
                Data: combineReducers({
                    '@index': pipeReducers(
                        networkEntityAddReducer(NetworkActionPrefix.ADD_USER_DATA_VISIBILITY_LEGAL_ENTITY_PREFIX, null, (state, action) => action.legalEntity),
                        networkEntityDeleteReducer(NetworkActionPrefix.DELETE_USER_DATA_VISIBILITY_LEGAL_ENTITY_PREFIX, defaults.UserDataVisibilityLegalEntity)
                    )
                }, {
                    index: (state, action) => index(state, action.legalEntityID)
                })
            })
        ),
        userDataVisibilityProducts: pipeReducers(
            networkObjectLoadReducer(NetworkActionPrefix.LOAD_USER_DATA_VISIBILITY_PRODUCTS_PREFIX, defaults.NetworkArrayOf(defaults.UserDataVisibilityProduct)),
            combineReducers({
                Data: combineReducers({
                    '@index': pipeReducers(
                        networkEntityAddReducer(NetworkActionPrefix.ADD_USER_DATA_VISIBILITY_PRODUCT_PREFIX, null, (state, action) => action.product),
                        networkEntityDeleteReducer(NetworkActionPrefix.DELETE_USER_DATA_VISIBILITY_PRODUCT_PREFIX, defaults.UserDataVisibilityProduct)
                    )
                }, {
                    index: (state, action) => index(state, action.productID)
                })
            })
        ),
        userDataVisibilitySettings: pipeReducers(
            networkObjectLoadReducer(NetworkActionPrefix.LOAD_USER_DATA_VISIBILITY_SETTINGS_PREFIX, defaults.NetworkArrayOf(defaults.UserDataVisibilitySettings)),
            combineReducers({
                Data: combineReducers({
                    '@index': pipeReducers(
                        networkEntityAddReducer(NetworkActionPrefix.ADD_USER_DATA_VISIBILITY_SETTINGS_PREFIX, null, (state, action) => action.settings),
                        networkEntityEditReducer(NetworkActionPrefix.EDIT_USER_DATA_VISIBILITY_SETTINGS_PREFIX, null, (state, action) => action.settings)
                    )
                }, {
                    index: (state, action) => index(state, action.settingsID)
                })
            })
        ),
        userReport: networkObjectLoadReducer(NetworkActionPrefix.LOAD_USER_LIST_REPORT_PREFIX, defaults.NetworkArrayOf(defaults.UserListReport)),
        userRoles: networkObjectLoadReducer(NetworkActionPrefix.LOAD_USER_ROLES_PREFIX, defaults.NetworkArrayOf(defaults.UserRole)),
        userRoleProducts: pipeReducers(
            networkObjectLoadReducer(NetworkActionPrefix.LOAD_USER_ROLE_PRODUCTS_PREFIX, defaults.NetworkArrayOf(defaults.UserRoleProduct)),
            combineReducers({
                Data: combineReducers({
                    '@index': pipeReducers(
                        networkEntityAddReducer(NetworkActionPrefix.ADD_USER_ROLE_PRODUCT_PREFIX, null, (state, action) => action.roleProduct),
                        networkEntityDeleteReducer(NetworkActionPrefix.DELETE_USER_ROLE_PRODUCT_PREFIX, defaults.UserRoleProduct)
                    )
                }, {
                    index: (state, action) => index(state, action.roleProductID)
                })
            })
        )
    }),
    (state, action) => {
        switch (action.type) {
            case ActionType.VOID_CORPORATE_STRUCTURE:
            case ActionType.DELETE_PRODUCT_SUCCESS:
            case ActionType.DELETE_CUSTOMER_SUCCESS:
            case ActionType.DELETE_TRACKING_LEVEL_1_ITEM_SUCCESS:
            case ActionType.DELETE_TRACKING_LEVEL_2_ITEM_SUCCESS:
            case ActionType.DELETE_TRACKING_LEVEL_3_ITEM_SUCCESS:
            case ActionType.DELETE_TRACKING_LEVEL_4_ITEM_SUCCESS:
                // TODO make it more targeted, not all parts require update
                return userList(undefined, { type: '@@redux/INIT' });
            default:
                return state;
        }
    }
);

export default userList;
